import { useCallback, useState } from "react";

export function useFixedPopover() {
	const [state, setState] = useState({
		visible: false,
		anchorRect: null,
		title: "",
		sections: [],
	});

	const hide = useCallback(() => {
		setState({ visible: false, anchorRect: null, title: "", sections: [] });
	}, []);

	const getHoverHandlers = useCallback(
		({ title, sections }) => {
			if (!sections?.length && !title) {
				return {};
			}

			return {
				onMouseEnter: (event) => {
					const rect = event.currentTarget.getBoundingClientRect();
					setState({
						visible: true,
						anchorRect: rect,
						title: title || "",
						sections: sections || [],
					});
				},
				onMouseLeave: hide,
			};
		},
		[hide]
	);

	return {
		popoverProps: {
			visible: state.visible,
			anchorRect: state.anchorRect,
			title: state.title,
			sections: state.sections,
		},
		getHoverHandlers,
		hide,
	};
}
